import { render, staticRenderFns } from "./privacy-policy.vue?vue&type=template&id=136f07e3&scoped=true&"
var script = {}
import style0 from "./privacy-policy.vue?vue&type=style&index=0&id=136f07e3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f07e3",
  null
  
)

export default component.exports